document.addEventListener("DOMContentLoaded", function () {

    //Brands page start
    const gridContainer = document.createElement("div");
    gridContainer.classList.add("grid-brands-container");

    // Select all .grid_item elements inside .shopify-section
    document.querySelectorAll(".brands .shopify-section .grid_item").forEach(item => {
        gridContainer.appendChild(item);
    });

    // Add the combined grid items to the body (or specific parent)
    const parentContainer = document.querySelector(".brands #site-main .html--section");

    if (parentContainer) {
        parentContainer.prepend(gridContainer);
    }
    //Brands page end
});


function selectVariant() {
    const selectedVar = document.querySelector(".options-selection__input-select");
    var option = selectedVar.options[selectedVar.selectedIndex];
    var optionqty = option.getAttribute("data-optionqty");

    //document.querySelector(".dispatching").classList.add("inactive");
    document.querySelector(".dispatch_default_icons").classList.add("inactive");

    if (optionqty != "0" && optionqty.indexOf("-") === -1){
        document.querySelector(".instock").classList.add("active");
        document.querySelector(".outofstock").classList.remove("active");

        document.querySelector(".icon_instock").classList.add("active");
        document.querySelector(".icon_outofstock").classList.remove("active");
    }     
    else{
        document.querySelector(".outofstock").classList.add("active");
        document.querySelector(".instock").classList.remove("active");

        document.querySelector(".icon_outofstock").classList.add("active");
        document.querySelector(".icon_instock").classList.remove("active");
    }        
}

var partsFinderClick = document.getElementById("js_drop_parts");
var partsFinderBody = document.getElementById("js_partsfinder_body");


partsFinderClick.addEventListener("click", function() {
    partsFinderBody.classList.toggle("active");
    
    var currentValue = partsFinderClick.getAttribute("data-accordion-trigger");
    var newValue = (currentValue === "closed") ? "open" : "closed";
    partsFinderClick.setAttribute("data-accordion-trigger", newValue);
});

if(document.querySelector('a[href*="openlivechat"]')){
    document.addEventListener('DOMContentLoaded', function() {
        var liveChatOpen = document.querySelector('a[href*="openlivechat"]');
        liveChatOpen.addEventListener('click', function(event) {
            event.preventDefault();

            function clickChatButton() {
                const chatElement = document.querySelector('inbox-online-store-chat');
                if (chatElement && chatElement.shadowRoot) {
                    const chatButton = chatElement.shadowRoot.querySelector('.chat-toggle');
                    if (chatButton) {
                        chatButton.click();
                        return true; 
                    }
                }
                return false; 
            }

            if (!clickChatButton()) {
                const observer = new MutationObserver((mutationsList, observer) => {
                    if (clickChatButton()) {
                        observer.disconnect(); 
                    }
                });
                observer.observe(document.body, { childList: true, subtree: true });
            }
        });
    });
}

// Product page - Model Matching functionality
const productDetails = document.querySelector('.product-details'); // Product Detail

if (productDetails) {
    // console.log('Product details element');
    
    document.addEventListener('easysearch_fitment_toggled', function(e){
        
        //console.log("easysearch.currentTag: " + [easysearch.currentTag]);
        
        // Easysearch Matching information
        const status = e.detail.status;
        const matchedTag = [easysearch.currentTag];

        console.log("Fitment status: " + status);

        const matchContainer = document.getElementById('fitment-also-matches');
        const matchProductsContainer = document.getElementById('fitment-also-matches-products');
        
        // Only run if we have a match
        if(status=="fit"){
            const productDataElement = document.getElementById('product-modalmatch-json');
            if (productDataElement) {

                const productData = JSON.parse(productDataElement.textContent);
                const additionalProducts = productData.additional_products;
                //console.log('Additional products:', additionalProducts);

                // Find matching additional products based on tags
                const matchedProducts = additionalProducts.filter(product => {
                    return product.tags.some(tag => matchedTag.includes(tag));
                });

                // If we have matched products, display them
                if (matchedProducts.length > 0) {

                    if (matchContainer && matchProductsContainer) {
                        matchContainer.classList.add('matches');
                        
                        matchProductsContainer.innerHTML = '';
                        
                        matchedProducts.forEach(product => {
                            const productItem = document.createElement('div');
                            productItem.className = 'matched-product';
                            productItem.innerHTML = `
                                <div class="match-card">
                                    <a href="${product.url}" title="${product.title}" class="match-img"><img src="${product.image}" alt="${product.title}" /></a>
                                    <h4><a href="${product.url}" title="${product.title}">${product.title}</a></h4>
                                    <div class="match-sku"><small>${product.sku}</small></div>
                                </div>
                            `;
                            matchProductsContainer.appendChild(productItem);
                        });
                    }


                    // Render out the results
                }
            }
        }else{
            matchProductsContainer.innerHTML = '';
            matchContainer.classList.remove('matches');
        }
        
        
        // 2025-yamaha-dt-125-r-pro-tank-ring-black--yamaha-t-n-r--700-world-raid---rally-esr2950604
    });
        
    
} 

(function ($, root, undefined) {

    if(jQuery('.jsmobhide').length){
        if (jQuery(window).width() < 769) {
            jQuery('.jsmobhide').remove();
        }
    }

    $(document).ready(function(){

        function setCookie(name, value, seconds) {
            var expires = "";
            if (seconds) {
                var date = new Date();
                date.setTime(date.getTime() + (seconds * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
        }

        function isCookieExpired(cookieName) {
            var cookie = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
            return cookie ? new Date() > new Date(cookie.pop()) : true;
        }

        function isCookieNotSet(cookieName) {
            return document.cookie.indexOf(cookieName + '=') === -1;
        }

        function isCookieSet(cookieName) {
            return document.cookie.indexOf(cookieName + '=') !== -1;
        }

        function clearCookie(name) {
            document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
        //clearCookie("cookieName");

        /*** Page Aftermarket parts finder page ***/ 
        if ($('.seeker').length) {
            const checkFieldsValue = setInterval(() => {

                const dropdown = document.querySelector('seeker-dropdown-parts-finder');

                if (!dropdown || !dropdown.shadowRoot) return;

                const selectYear = dropdown.shadowRoot.querySelector('select[name="year"]');
                const selectMake = dropdown.shadowRoot.querySelector('select[name="make"]');
                const selectModel = dropdown.shadowRoot.querySelector('select[name="model"]');

                if (selectYear && selectMake && selectModel) {
                    // Function to update heading
                    const updateHeading = () => {

                        const yearTextRaw = selectYear.options[selectYear.selectedIndex]?.text?.trim();
                        const yearText = (yearTextRaw && yearTextRaw.toLowerCase() !== 'select year') ? yearTextRaw : '';

                        const makeTextRaw = selectMake.options[selectMake.selectedIndex]?.text?.trim();
                        const makeText = (makeTextRaw && makeTextRaw.toLowerCase() !== 'select make') ? makeTextRaw : '';

                        const modelTextRaw = selectModel.options[selectModel.selectedIndex]?.text?.trim();
                        const modelText = (modelTextRaw && modelTextRaw.toLowerCase() !== 'select model') ? modelTextRaw : '';

                        // console.log('Selected year:', yearText);
                        // console.log('Selected make:', makeText);
                        // console.log('Selected model:', modelText);

                        $(".seeker-heading").text("PARTS FOR - " + makeText + " " + modelText + " " + yearText);
                    };

                    // Run once immediately after load
                    updateHeading();

                    // Add listeners for changes
                    $(selectYear).off("change").on("change", updateHeading);
                    $(selectMake).off("change").on("change", updateHeading);
                    $(selectModel).off("change").on("change", updateHeading);

                    setTimeout(() => {
                        clearInterval(checkFieldsValue);
                    }, 60000);//end after 1 minute
                }
            }, 300);
        }
        /*** Page Aftermarket parts finder page ***/ 

        /*** Section Aftermarket parts ***/ 
        if($('.collection-afmp-section').length){

            $('.section-afmp-close').on('click', function(){ 
                $('.collection-afmp-section').removeClass('active'); 
            }); 
        }

        /*** Pop up Aftermarket parts***/
        if($('.popup-afmp-section').length && $('.template-collection').length){

            var _afterMarketsPartsCookie = "afterMarketsPartsCookie";
            var _afterMarketsPartsCookieVal = "after_markets_parts_cookie_true";

            $('.pop-afmp-close').on('click', function(){ 
                $('.popup-afmp-section').removeClass('active'); 
                $('body').removeClass('popup-afmp-active'); 

                setCookieTimeTypeAndDuration();

            });

            $(document).on('click', function (e) {
                if (!$(e.target).closest('.popup-afmp-content').length && $('.popup-afmp-section').hasClass('active')) {
                    $('.popup-afmp-section').removeClass('active');
                    $('body').removeClass('popup-afmp-active');

                    setCookieTimeTypeAndDuration();

                }
            });

            function setCookieTimeTypeAndDuration (){

                    var _afterMarketsPartsCookie = "afterMarketsPartsCookie";
                    var _afterMarketsPartsCookieVal = "after_markets_parts_cookie_true";
                    var get_cookie_time_duration = 0;

                    switch ( $('.popup-cookie').data("popupcookietimeduration") ) {
                        case "1-day":
                            get_cookie_time_duration = 86400;
                            break;
                        case "2-days":
                            get_cookie_time_duration = 172800;
                            break;
                        case "3-days":
                            get_cookie_time_duration = 259200;
                            break;
                        case "4-days":
                            get_cookie_time_duration = 345600;
                            break;
                        case "5-days":
                            get_cookie_time_duration = 432000;
                            break;
                        default:
                            get_cookie_time_duration = 86400;
                    }

                    if( $('.popup-cookie').data("popupcookietimetype") == "set-cookie-per-collection" ){
                        setCookiePerCollection(get_cookie_time_duration);
                    }else if( $('.popup-cookie').data("popupcookietimetype") == "set-cookie-first-only-collection" ){
                        setCookie(_afterMarketsPartsCookie, _afterMarketsPartsCookieVal, get_cookie_time_duration ); 
                    }else{
                        //
                    }
            }

            function setCookiePerCollection(secondsValue){
                if (window.location.pathname.startsWith("/collections/")) {
                    var collectionPath = window.location.pathname;
                    // Create a unique cookie name based on the collection path
                    var cookieName = "collection_visited_" + collectionPath.replace("/collections/", "").replace(/\W+/g, "_");
                    var cookieValue = collectionPath;

                    // Set the cookie for 1 day (86400 seconds)
                    setCookie(cookieName, cookieValue, secondsValue);
                }
            }

            function checkCookiePerCollection(secondsValue){
                if (window.location.pathname.startsWith("/collections/")) {

                    var collectionPath = window.location.pathname;
                    var cookieName = "collection_visited_" + collectionPath.replace("/collections/", "").replace(/\W+/g, "_");
                    var _afterMarketsPartsCookie = "afterMarketsPartsCookie";

                    if( $('.popup-cookie').data("popupcookietimetype") == "set-cookie-per-collection" ){
                        _afterMarketsPartsCookie = cookieName;
                    }

                    if (isCookieNotSet(_afterMarketsPartsCookie)){
                        //console.log(_afterMarketsPartsCookie + " not set yet...");
                        displayPopupAftermarkets();
                    } else if(!isCookieSet(_afterMarketsPartsCookie)){
                        //console.log(_afterMarketsPartsCookie + " cookie is set...");
                        displayPopupAftermarkets();
                    } else if (isCookieExpired(_afterMarketsPartsCookie)) {
                        //console.log(_afterMarketsPartsCookie + " is expired. Running code...");
                        displayPopupAftermarkets();
                    } else {

                    }
                }
            }
            checkCookiePerCollection();

            function displayPopupAftermarkets(){
                $('.popup-afmp-section').addClass('active');
                $('body').addClass('popup-afmp-active');
            }

            if( $('.popup-cookie').data("clearallaftermatketspopupcookie") == "true"){
                clearCookie(_afterMarketsPartsCookie);
            }
        }


        /*** Pop up Ride With US***/
        if($('.popup-section').length){

            var _rideWidthUsCookie = "rideWithUsCookie";
            var _rideWidthUsCookieVal = "ride_with_us_cookie_true";
        
            $('.pop-close').on('click', function(){ 
                $('.popup-section').removeClass('active'); 
                $('body').removeClass('popupactive'); 
                //We don't want to set cookie if click x close icon. Only the text I don't want free money text is clicked.
                //setCookie(_rideWidthUsCookie, _rideWidthUsCookieVal, 60); 1 min
                //setCookie(_rideWidthUsCookie, _rideWidthUsCookieVal, 30 * 24 * 60 * 60); 30 days
                //setCookie(_rideWidthUsCookie, _rideWidthUsCookieVal, 1 * 24 * 60 * 60); //1 day
            });
        
            $('body').on('click','.pop-closer', function(){ 
                $('.popup-section').removeClass('active'); 
                $('body').removeClass('popupactive'); 
                setCookie(_rideWidthUsCookie, _rideWidthUsCookieVal, 1 * 24 * 60 * 60); //1 day
            });
        
            var halfwaypage = false;
            var bottomOfPage = false;
            
            $('.popup-section ._button-wrapper button').removeClass('_submit'); 
            $('.popup-section ._button-wrapper button').text("JOIN THE CLUB");
            $('.popup-section ._button-wrapper button').after("<p class='pop-closer'>No, I don't want free money</p>");

            function displayPopup(){
                if(bottomOfPage == false){
                    $('body').addClass("popupactive");
                    $('.popup-section').addClass('active'); 
                }
            }

            //Bottom of page
            $(window).scroll(function () {
                if ($(window).scrollTop() + $(window).height() == $(document).height()) {

                    if(isCookieNotSet(_rideWidthUsCookie)){
                        //console.log(_rideWidthUsCookie + " not set yet");
                        displayPopup();
                        bottomOfPage = true;
                    }
                    else if(isCookieSet(_rideWidthUsCookie)){
                        bottomOfPage = true;
                        displayPopup();
                        //console.log(_rideWidthUsCookie + " cookie is set");
                    }
                    else if (isCookieExpired(_rideWidthUsCookie)) {
                        //console.log(_rideWidthUsCookie + " is expired. Running code...");
                        bottomOfPage = false;
                        displayPopup();
                        bottomOfPage = true;
                    } else {
                        //console.log(_rideWidthUsCookie + " is not expired.");
                    }
                }
            });

            //Halfway of page
            /*
            $(window).scroll(function () {
                // Check if the user has scrolled halfway through the page
                if ($(window).scrollTop() >= $(document).height() / 2) {
                }
            });
            */

            /*Footer Subscribe */
            $('.newsletter-activecampaign ._button-wrapper button').removeClass('_submit'); 
            $('.newsletter-activecampaign ._form_5 form').prop('style').setProperty('background', 'unset', 'important');
            $('.newsletter-activecampaign ._button-wrapper button').text("JOIN THE CLUB");
        }

        if($(".parts-banner-carousel").length){
            $(".parts-banner-carousel").slick({
                dots: true,
                autoplay: true,
                autoplaySpeed: 6000,
                infinite: false,
                speed: 1000,
                slide: '.slide',
                fade: true,
                cssEase: 'linear',
                "slidesToShow": 1,
                "slidesToScroll": 1,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 4000,
                            settings: {
                                slidesToShow: 1,
                                infinite: true,
                            }
                    }, {
                        breakpoint: 2500,
                            settings: {
                                slidesToShow: 1,
                                infinite: true,
                            }
                    }, {
                        breakpoint: 2000,
                            settings: {
                                slidesToShow: 1,
                                infinite: true,
                            }
                    }, {
                        breakpoint: 1500,
                            settings: {
                                slidesToShow: 1,
                                infinite: true,
                            }
                    }, {
                    breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            infinite: true,
                        }
                    }, {
                        breakpoint: 800,
                            settings: {
                                slidesToShow: 1,
                                autoplay: true,
                            }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                        }
                    }, {
                        breakpoint: 300,
                        settings: {
                            slidesToShow: 1,
                            autoplay: true
                        }
                    }]
            });
        }

        if($(".carousel-list").length){
            $(".carousel-list").slick({
                dots: false,
                autoplay: true,
                autoplaySpeed: 900,
                infinite: false,
                speed: 6000,
                slide: '.slide',
                cssEase: 'linear',
                "slidesToShow": 4,
                "slidesToScroll": 1,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 4000,
                            settings: {
                                slidesToShow: 4,
                                infinite: true,
                                dots: false,
                            }
                    }, {
                        breakpoint: 2500,
                            settings: {
                                slidesToShow: 4,
                                infinite: true,
                                dots: false,
                            }
                    }, {
                        breakpoint: 2000,
                            settings: {
                                slidesToShow: 4,
                                infinite: true,
                                dots: false,
                            }
                    }, {
                        breakpoint: 1500,
                            settings: {
                                slidesToShow: 4,
                                infinite: true,
                                dots: false,
                            }
                    }, {
                    breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            infinite: true,
                            dots: false,
                        }
                    }, {
                        breakpoint: 800,
                            settings: {
                                slidesToShow: 2,
                                autoplay: true,
                                dots: false,
                            }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            dots: true,
                            dots: false,
                        }
                    }, {
                        breakpoint: 300,
                        settings: {
                            slidesToShow: 1,
                            dots: false,
                            autoplay: true
                        }
                    }]
            });
            $(".carousel-list-container").removeClass('loading');
        }


        var bulkyIconClick = $(".bulky-clicker-js");
        var bulkymsgjs = $(".bulkymsgjs");
        var bulkyMsgClose = $(".bulky-msg-close");
        if(bulkyIconClick.length){
            bulkyIconClick.on("click", function () {  
                bulkymsgjs.toggleClass("active");
            });
            bulkyMsgClose.on("click", function () {  
                bulkymsgjs.removeClass("active");
            });
        }

    });



    // Show part number under product description
    if($('.dataprodsku').length && $('.product-sku span[data-product-sku]').text().length > 0){
        $('.dataprodsku').text($('.product-sku span[data-product-sku]').text());
    }else{
        $('.part--number').addClass('hide');
    }

})(jQuery, this);